import React, {useEffect, useState} from "react";
import ComboboxComponent from "../../components/Combobox";
import {getList} from "../../services/service";
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router";
import {withTranslation} from "react-i18next";
import {VscSaveAs} from "react-icons/vsc";
import Button from "../../components/Button";
import saveItem from "../../services/service";
import {getItem} from "../../services/service";
import {toast} from "react-toastify";

const AddConnection = ({t}) => {
    const [productList, setProductList] = useState([]);
    const [item1Id, setItem1Id] = useState(null);
    const [item2Id, setItem2Id] = useState(null);
    const [selectedItem, setSelectedItem] = useState({});
    const {token} = useSelector((state) => state.user);
    const navigate = useNavigate();
    const {id} = useParams();

    const handleChangeItemOne = (value) => {
        setItem1Id(value.id);
    };

    const handleChangeItemTwo = (value) => {
        setItem2Id(value.id);
    };

    const fetchList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article/product`,
            token
        );
        if (response.success) {
            setProductList(response.data);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };
    const getDataOne = async (id) => {
        const response = await getItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/${id}`,
            token
        );
        if (response.success) {
            setSelectedItem(response.data);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchList();
        if (id) {
            getDataOne(id);
        }
    }, []);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const response = await saveItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection`,
            token,
            {
                id: id ? id : null,
                product1: item1Id ? item1Id : selectedItem.product1,
                product2: item2Id ? item2Id : selectedItem.product2,
            }
        );
        if (response.success) {
            navigate("/connection");
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="shadow sm:rounded-md">
                <div className="space-y-6 bg-white py-6 px-4 sm:p-6">
                    <div>
                        <h3 className="text-lg font-medium leading-6 text-gray-900">
                            {id ? t(`table.connection.edit`) : t(`table.connection.add`)}
                        </h3>
                    </div>

                    <div className="grid grid-cols-6 gap-6">
                        <div className="col-span-6 sm:col-span-3">
                            <ComboboxComponent
                                data={productList}
                                label={t(`products`)  + " 1"}
                                onChange={handleChangeItemOne}
                                item={productList.find(
                                    (item) => item.id === selectedItem?.product1
                                )}
                            />
                        </div>
                        <br/>
                        <div className="col-span-6 sm:col-span-3">
                            <ComboboxComponent
                                data={productList}
                                label={t(`products`)  + " 2"}
                                onChange={handleChangeItemTwo}
                                item={productList.find(
                                    (item) => item.id === selectedItem?.product2
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 text-right sm:px-6 flex items-center justify-end">
                    <Button type="button" to="/connection" btnName={t(`backward`)}/>
                    <button
                        type="submit"
                        className="flex items-center justify-center px-4 py-1 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        {t(`save`)}
                        <VscSaveAs className="w-4 h-4 ml-1"/>
                    </button>
                </div>
            </div>
        </form>
    );
};

export default withTranslation()(AddConnection);
